import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

export default class AlertsLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Weather Alerts";
		this.popupName = "Alerts";
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;
		this.alerts = {};
		this.dataOptions = {};

		this.filters = {
			"sf": ["TOR", "SVR", "FFW", "SMW", "SVS", "SPS"],
			"wsw": ["WSW"]
		};
	}
	
	refreshLayer() {
		this.requestAlerts();
	}
	
	requestAlerts() {
		this.inst.setLoadingMonitor(this.id, true);
		if(typeof this.dataOptions.queryType === 'undefined') this.dataOptions.queryType = 'all';
		if(this.tasks.fetchAlerts === undefined) this.tasks.fetchAlerts = new Request({
			url: 'https://api.weatherusa.net/v1.2/feed/alerts',
			data: {mode: 'layer'},
			link: 'cancel',
			timeout: 45000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchAlerts.get({only: this.dataOptions.queryType}, true);
	}

	requestAlertsForLocation(q, callbackEl) {
		if(this.tasks.fetchAlertText === undefined) this.tasks.fetchAlertText = new Request({
			url: 'https://api.weatherusa.net/v1.2/feed/alerts',
			link: 'cancel',
			timeout: 45000,
			onSuccess: this.handleAlertSearchResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchAlertText.get({q: q, data: 1, callbackEl: callbackEl});
	}

	handleError(err) {
		console.error(err);
		this.inst.setLoadingMonitor(this.id, false);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}

		var alertFilter = ($('#alerts_option').val() || 'all');
		
		let list = resp.body;
		// Remove all paths from LayerGroup
		this.layer.clearLayers();
		this.alerts = {};

		for(const [id, data] of Object.entries(list)) {
			// Alert type filter
			if(alertFilter !== 'all' && !this.filters[alertFilter].includes(data.prod)) continue;

			let pathOptions = {
				fillColor: data.fill,
				fillOpacity: 0.30,
				color: data.outl,
				weight: 1,
				opacity: 1.0
			};
			if(data.prod == 'TOR' || data.prod == 'SVR' || data.prod == 'FFW' || data.prod == 'SVS') {
				pathOptions['weight'] = 2;
				pathOptions['fillOpacity'] = 0.16;
			}
			
			if(data.poly.type)
			{
				// GeoJSON
				this.alerts[id] = L.geoJSON(data.poly, pathOptions).addTo(this.layer);
			} else {
				var polyPath = [];
				try {
					data.poly.forEach(function(pt) {
						polyPath.push(L.latLng(pt[0], pt[1]));
					});
					this.alerts[id] = L.polygon([polyPath], pathOptions).addTo(this.layer);
				}
				catch(e) {
					console.log(e, data);
					continue;
				}
			}
			// this.alerts[id]._wxdata = data;
			this.alerts[id].on('click', this.handleClick, this);
			this.alerts[id].productId = data.id;
			this.alerts[id].productType = data.prod;
		}

		// Kinda hack to make important polys come to front
		for(const [id, item] of Object.entries(this.alerts)) {
			if(item.productType == 'TOR' || item.productType == 'SVR' || item.productType == 'FFW' || item.productType == 'SVS' || item.productType == 'SPS') {
				item.bringToFront();
			}
		}

		this.inst.setLoadingMonitor(this.id, false);
	}

	handleAlertSearchResp(resp) {
		let obj = resp.body;
		let $container = $('#' + obj.callbackEl);
		if($container.length == 0) {
			// Pop-up closed or container ID not found
			return false;
		}

		let content = '';
		for(let prod of obj.data) {
			content = content + '<a target="_blank" href="/wxwarnings?id=' + prod.id + '">' + prod.name + '</a><br>' + prod.data + '<hr>';
		}
		if(content === '') {
			content = '<em>No alerts found at chosen location. Zoom in for higher accuracy.</em>';
		}
		$container.html(content);
		if(this.inst.popup && this.inst.popup.isOpen()) this.inst.popup.update();
	}

	handleClick(e) {
		// Show one tab in popup
		e.coalesce = true;
		// Dynamic content (lat/lon search) or layer has multiple features that overlap each other, stop all bubbled events
		e.singleton = true;
		var containerId = "view_alerts_" + (new Date()).getTime();
		var bubbled = this.inst.forwardedClickHandler(this.id, e, '<div id="' + containerId + '" class="alerts-text-view"><img src="/images/mediabox/loading_sun_blue.gif" width="28" style="vertical-align: middle" alt="Please wait..." /> Loading...</div>');
		if(bubbled) {
			// Fetch actual alert text from API...
			this.requestAlertsForLocation("" + e.latlng.lat + "," + e.latlng.lng, containerId);
		}
	}

	getLayerPopupContent(layer) {
		// TODO not used

		// Show one tab in popup
		e.coalesce = true;
		// Dynamic content (lat/lon search) or layer has multiple features that overlap each other, stop all bubbled events
		e.singleton = true;
		var containerId = "view_alerts_" + layer.productId;
		// Fetch actual alert text from API...
		this.requestAlertsForLocation("" + layer.latlng.lat + "," + layer.latlng.lng, containerId);
	}
}